import React, { useState } from 'react';
import './css/services.css';

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="faq-item">
      <div onClick={toggle} className="faq-question">
        <strong>{question}</strong>
        <span>{isOpen ? '▲' : '▼'}</span>
      </div>
      {isOpen && (
        <div className="faq-answer">
          {answer}
        </div>
      )}
    </div>
  );
};

const FAQList = () => {
  const faqs = [
     {
    question: 'Which platforms do you manage for social media marketing?',
    answer: 'We manage Facebook, Instagram, LinkedIn, Twitter, TikTok, and YouTube depending on your audience and goals.',
  },
  {
    question: 'What is included in your social media service?',
    answer: 'Our services include strategy development, content creation, calendar planning, publishing, paid campaigns, and performance reporting.',
  },
  {
    question: 'Can you handle both organic and paid campaigns?',
    answer: 'Yes, we run both organic engagement strategies and targeted paid ads to maximize your social media ROI.',
  },
  {
    question: 'Do you create social media content too?',
    answer: 'Yes, we design posts, write captions, create videos or reels, and even handle community engagement if needed.',
  },
  {
    question: 'How often will you post on our social media pages?',
    answer: 'Posting frequency depends on the plan you choose—typically ranging from 3 to 7 times a week.',
  },
  {
    question: 'Will I get a monthly performance report?',
    answer: 'Yes, we provide detailed monthly reports including engagement, reach, impressions, growth, and suggestions for improvement.',
  },
    // Add more questions and answers as needed
  ];

  return (
    <div>
      {faqs.map((faq, index) => (
        <FAQItem key={index} question={faq.question} answer={faq.answer} />
      ))}
    </div>
  );
};

const App = () => {
  return (
    <div style={{ padding: '5%' }}>
      <div className="seo-main-faq">
    <div className="seo-main-heading">
      <h1>FAQ’S</h1>
    </div>
      <div className="seo-main-para">
        <p></p>
      </div>
      </div>
      <FAQList />
    </div>
  );
};

export default App;
